import React from "react";

const Intern = () => {
  return (
    <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '100vh' }}>
      <h1>Interns Page</h1>
      <p>Coming Soon</p>
    </div>
  );
};

export default Intern;
